import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-04",
  "use": "icon-button_icon-04-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-04\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\"><path d=\"M17.479 9.002h2.703c1.004 0 1.818.767 1.818 1.714v8.571c0 .947-.814 1.715-1.818 1.715H3.818C2.814 21.002 2 20.234 2 19.287v-8.571c0-.947.814-1.714 1.818-1.714h2.683M12 16.002v-14M12 1.88l4.242 4.243M7.753 6.123L12 1.88\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol